module.exports = __webpack_public_path__ + "static/media/google.341a715e.png";